import { Users } from './users';
import { Profession } from './profession';
import { Personne } from "./personne";
import { Personnel } from './personnel';
import { ProgrammationLotDialyse } from './programmation-lot-dialyse';
import { Corps } from './corps';
import { Grade } from './grade';
import { Pays } from './pays';
import { SortieDialyse } from './sortie-dialyse';

export class Patients {
  id: number;
  prenom: string;
  nom: string;
  sexe: string;
  civilite: string;
  numero: number;
  codepatient: string;
  datenaissance: any;
  lieunaissance: string;
  cni: string;
  diagnostic: string;
  service_origine: string;
  typePatient: string;
  portable: string;
  fixe: string;
  bureau: string;
  email: string;
  matrimoniale: string;
  nbreEnfants: number  = 0;
  activite: string;
  langue: string;
  adresse: string;
  dateCreation: any;
  pays: Pays;
  nationalite: string;
  actif: boolean;
  metier: Profession;
  contacts: Personne[];
  createur: Users ;
  nephrologue: Personnel;
  bp: string;
  medecinTraitant: Personnel;
  medecin1: Personnel;
  medecin2: Personnel;
  lot: ProgrammationLotDialyse;
  sortieDialyse: any;
  corps: Corps;
  grade: Grade;
  matricule: string;

  autres: string;
  lieuTravaille: string;


  photo : string;

  public toString(): string {
    return `${this.codepatient}: ${this.prenom} ${this.nom}`;
  }

}

export class PatientExport {
  Code: string;
  Portable: string;
  Sexe: string;
  Prénom: string;
  Nom: string;
  Date_Naissance: string;
  Pays: string;
  Nationnalité: string;
}

export class PatientSortieExport {
  Code: string;
  Sexe: string;
  Prénom: string;
  Nom: string;
  Date_Naissance: string;
  Date_Sortie: string;
  Type_Sortie: string;
  Description: string;
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/patients.ts